import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { GetFindTestAccountsQuery } from "@/api/hasura/generated/graphql"
import { ITestAccount } from "@/models/admin/testAccount/testAccount.types"
import { TestAccountParser } from "@/models/admin/testAccount/testAccount.parser"

class TestAccountsServiceClass {
  getTestAccounts(): QueryResult<ITestAccount[]> {
    return useQuery({
      ...HasuraQueries.testAccounts.list(),
      useRawResponse: true,
      placeholderData: [],
      parserFn: (data: GetFindTestAccountsQuery): ITestAccount[] => {
        const items = data?.find_test_accounts ?? []
        return items.map((item) => TestAccountParser.toDomain(item))
      },
    })
  }
}

export const TestAccountsService = new TestAccountsServiceClass()
